import { useLocation, useParams } from 'react-router-dom';
import NativeAccountPage, { safeAuthNext } from './NativeAccountPage';

const providerPaths: Record<string, string> = {
  github: '/accounts/github/login/',
  google: '/accounts/google/login/',
  twitter_oauth2: '/accounts/twitter_oauth2/login/',
};
export default function SocialLoginForm() {
  const { providerId } = useParams<{ providerId: string }>();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const path = providerId ? providerPaths[providerId] : undefined;
  const connecting = location.pathname.includes('/connect/');
  query.set('process', connecting ? 'connect' : 'login');
  query.set('next', safeAuthNext(query.get('next'), connecting ? '/auth/profile' : '/'));
  return (
    <NativeAccountPage
      title={connecting ? 'Connect an Account' : 'More Sign-In Options'}
      description={
        providerId && !path
          ? 'Choose an available sign-in provider to continue.'
          : 'Continue with the available account providers.'
      }
      label={connecting ? 'Continue Connecting' : 'Continue Sign-In'}
      href={`${path || '/accounts/login/'}?${query}`}
    />
  );
}
